import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const Error404 = () => {

  return (
    <HomeUI />
  )
}

export default Error404